/**
 * @fileoverview A caixa de aceite dos Termos de Uso e da Política de Privacidade
 * (03/11/2026): obrigatória e desmarcada, com os links abrindo em outra aba, para quem
 * não perder o que já digitou. O servidor confere de novo.
 */

import React from "react";

import { i18n } from "../../translate/i18n";
import { useAuthFormStyles } from "./formStyles";

export const TERMS_URL = "https://sttelar.pro/termos/";
export const PRIVACY_URL = "https://sttelar.pro/privacidade/";

const TermsCheckbox = ({ id, checked, onChange, error }) => {
  const classes = useAuthFormStyles();
  const errorId = `${id}-error`;
  const linkStyle = { fontSize: "inherit", fontWeight: 400 };
  return (
    <div className={classes.field}>
      <label className={classes.check} htmlFor={id} style={{ alignItems: "flex-start", userSelect: "auto" }}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          style={{ marginTop: 2, flexShrink: 0 }}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
        />
        <span style={{ fontSize: 13.5, lineHeight: 1.45 }}>
          {i18n.t("auth.signup.legalPrefix")}{" "}
          <a className={classes.link} style={linkStyle} href={TERMS_URL} target="_blank" rel="noopener noreferrer">{i18n.t("auth.signup.legalTerms")}</a>{" "}
          {i18n.t("auth.signup.legalAnd")}{" "}
          <a className={classes.link} style={linkStyle} href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">{i18n.t("auth.signup.legalPrivacy")}</a>.
        </span>
      </label>
      {error && <div id={errorId} className={classes.error} role="alert">{error}</div>}
    </div>
  );
};

export default TermsCheckbox;
